





















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ShowDevDialog extends Vue {
    // Text input for admin code dialog
    private adminCode: string = "";
    private correctCode = "4321";
    private adminCodeError = "";

    private showDevDialog = false;

    private testAdminCode(code: string) {

        if (code === this.correctCode) {

            this.$router.push('/dev').catch((err) => { return; });
        } else {
            this.adminCodeError = "code incorrect";
        }
    }
}
